export default "__VITE_ASSET__DE8eY$zR__"